module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Tools-4877250f481427b44ccda900a7e6d79ce3b433c0891761eae927e261d1802443.svg";